import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['number', 'numberPresenter']

  increment(event) {
    event.preventDefault();
    this.numberTarget.stepUp();
    this.render();
  }

  decrement(event) {
    event.preventDefault();
    this.numberTarget.stepDown();
    this.render();
  }

  render() {
    this.numberPresenterTarget.textContent = this.numberTarget.value;
  }
}
